import { NETWORKS, TRANSACTION_SOURCES, SUBNETWORKS } from './dictionary/index.js';

export default function getTransactionSource({ source, network, subnetwork }) {
  return source === 'NETWORK'
    ? [NETWORKS[network], SUBNETWORKS[subnetwork]].filter(Boolean).join(' - ')
    : TRANSACTION_SOURCES[source];
}
